import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    LinearProgress,
    useTheme,
} from "@mui/material";
import spark_logo from "../../../assets/baseVersion/spark_byVerastel.svg"
import Lock_img from "../../../assets/baseVersion/vpn_lock.png"
import Trash_img from "../../../assets/baseVersion/delete.png"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";



import { END_POINTS } from "../../../shared";
import axiosInstance from "../../../axios/axios";
import { AxiosProgressEvent } from "axios";
import { useAuth, useStorageManager, useTokens } from "../../../shared/hooks";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";



interface DeleteConfirmationProps {
    open?: boolean;
    onClose?: () => void;
    onUpgrade?: () => void;
    onSignOut?: () => void;
}

const DeleteConfirmation = () => {
    const [isSuccessDelete, setIsSuccessDelete] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const theme = useTheme();
    const { getFromLocalStorage } = useStorageManager();
    const { logout } = useAuth();
    const { clearTokens } = useTokens();
    const navigate = useNavigate();

    const [progress, setProgress] = useState<number>(0);
    const [deleteSuccess, setDeleteSuccess] = useState<boolean>(false);

    useEffect(() => {
        //const userDetails:any = getFromLocalStorage("userDetails");
        const userDetails:any = JSON.parse(getFromLocalStorage("userDetails") || "{}");
        if (!userDetails || !userDetails.organization_id) {
            toast.error("You don’t have permission to access this page.");
            navigate("/login");
            return;
        }
        const deleteOrganization = async () => {
            const req = {
                organization_id: userDetails?.organization_id,
            };

            try {
                const response = await axiosInstance.post(END_POINTS.DELETE_ORG, req, {
                    onUploadProgress: (progressEvent: AxiosProgressEvent) => {
                        const total = progressEvent.total ?? 100; // Fallback to 100 if undefined
                        const percent = Math.round((progressEvent.loaded * 100) / total);
                        setProgress(percent);
                    },
                });

                // Optionally handle success
                console.log("Delete response:", response.data);
                if (response.status === 200) {
                    setDeleteSuccess(true);
                }
            } catch (error) {
                console.error("Delete failed:", error);
            }
        };

        deleteOrganization();
    }, []);



    const handleLogout = async () => {
        await logout();
        clearTokens();
        navigate("/login");
        // store.dispatch(authActions.logout());
        // window.location.href = "/login";
      };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f8f8fb",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                px: 2,
            }}
        >
            <img src={spark_logo} alt="Spark Logo" style={{ width: 120, marginBottom: 8 }} />
            {!deleteSuccess ? (
                <>
                

            <Typography variant="h5" fontWeight={600} gutterBottom>
                Deleting data permanently!
            </Typography>

            <Box display="flex" alignItems="center" gap={2} my={4}>
                <img src={Lock_img} alt="Secure" style={{ width: 40 }} />
                <svg height="30" width="80">
                    <line
                        x1="0"
                        y1="15"
                        x2="80"
                        y2="15"
                        stroke="#d4a6f5"
                        strokeDasharray="5,5"
                        strokeWidth="2"
                    />
                </svg>
                <img src={Trash_img} alt="Delete" style={{ width: 40 }} />
            </Box>

            <Typography variant="body2" color="text.secondary" mb={2}>
                Give us a moment we are deleting your data from our database
            </Typography>

            <Box sx={{ width: 300 }}>
                <LinearProgress variant="determinate" value={progress} />
                <Typography variant="body2" mt={1}>
                    {progress}%
                </Typography>
            </Box>

                </>
            ):(<> 
            <CheckCircleOutlineIcon
            sx={{ fontSize: 60, color: "green", mb: 2 }}
          />
          <Typography variant="h6" fontWeight={600}>
            Your data has deleted successfully!
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            mt={1}
            mb={3}
            sx={{ maxWidth: 300 }}
          >
            We don’t have any data in your database now. Kindly upgrade to our
            paid subscriptions to start freshly
          </Typography>

          <Box display="flex" gap={2}>
            {/* <Button
              variant="contained"
              sx={{
                background: "#5e00f7",
                textTransform: "none",
                "&:hover": { background: "#4a00c4" },
              }}
            >
              Upgrade!
            </Button> */}
            <Button
              variant="outlined"
              sx={{
                borderColor: "#f75f5f",
                color: "#f75f5f",
                textTransform: "none",
                "&:hover": {
                  borderColor: "#f75f5f",
                  backgroundColor: "#ffeaea",
                },
              }}
              onClick={handleLogout}
            >
              Sign Out
            </Button>
          </Box>
               </>)}
            
        </Box>
    );
};

export default DeleteConfirmation;
